<template>
  <div class="layout-buttons-exemplo-content" id="identidade-visual-botoes" data-search-anchor>
    <div class="title-layout-buttons-exemplo-wrapper">
      <h1 class="layout-buttons-exemplo-title-span">{{ layoutButtonsExemploTitleSpan }}</h1>
      <h1 class="layout-buttons-exemplo-title">{{ layoutButtonsExemploTitle }}</h1>
    </div>
    <div class="descriptiom-layout-buttons-exemplo-wrapper">
      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-buttons-exemplo-description">{{ layoutButtonsExemploDescription1 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-buttons-exemplo-description">{{ layoutButtonsExemploDescription2 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-buttons-exemplo-description">{{ layoutButtonsExemploDescription3 }}</p>
      </div>
    </div>
    <div
      class="layout-buttons-exemplo-card-item"
      :style="{ backgroundImage: `url(${layoutButtonsExemploImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LayoutsButtonsExemploSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  get layoutButtonsExemploTitleSpan(): string {
    return this.getElementTitle(18, 0)
  }

  get layoutButtonsExemploTitle(): string {
    return this.getElementText(18, 0)
  }

  get layoutButtonsExemploDescription1(): string {
    return this.getElementText(18, 1)
  }

  get layoutButtonsExemploDescription2(): string {
    return this.getElementText(18, 2)
  }

  get layoutButtonsExemploDescription3(): string {
    return this.getElementText(18, 3)
  }

  get layoutButtonsExemploImageSrc(): string {
    return this.getElementMedia(18, 4)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layout-buttons-exemplo-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.title-layout-buttons-exemplo-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding: 6.25rem 0rem 2rem 0rem;
}

.layout-buttons-exemplo-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #b3b3b3;
}

.layout-buttons-exemplo-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.descriptiom-layout-buttons-exemplo-wrapper {  
  position: relative;  

  display: grid;
  grid-template-columns: 51% 49%;  
  padding-bottom: 1rem;
}

.layout-buttons-exemplo-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px;
}

.layout-buttons-exemplo-card-item {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-size: contain;
}
</style>
